import request from '@core/services/request';

export const azureOcrAPI = {
	generalDocumentExtract: (formData: any) => request.post(`/OCR/GeneralDocumentExtract`, formData),
};
